import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { SEOProps } from './types'

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  canonical,
  keywords,
  image = 'https://www.barberinnovations.com/logo.jpg',
  type = 'website',
  twitterCard = 'summary_large_image'
}) => {
  return (
    <Helmet>
      {/* Primary SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}

export default SEO
